module.exports = __webpack_public_path__ + "static/stand-out-blue-b5d12975eaeba15c2a6fc2e957237773.svg";